import { Navigate, Route, Routes } from 'react-router-dom';
import { DashboardNav } from '../shared/components/dashboard/DashboardNav';
import { DashboardOverviewPage } from './DashboardOverviewPage';
import { DashboardPositioningPage } from './DashboardPositioningPage';
import InsightsInvestorsPage from './InsightsInvestorsPage';
import { insightsService, personaService } from '../shared/services/personaService';
import { DashboardProvider } from '../shared/providers/DashboardProvider';

export default function InsightsPage() {
  return (
    <DashboardProvider service={insightsService} favouriteService={personaService}>
      <DashboardNav basePath="/insights" environmentTag="Insights" />
      <Routes>
        <Route index element={<Navigate to="/insights/positioning" replace />} />
        <Route path="positioning" element={<DashboardPositioningPage />} />
        <Route
          path="investors"
          element={<InsightsInvestorsPage />}
        />
        <Route
          path="overview"
          element={<DashboardOverviewPage service={insightsService} />}
        />
      </Routes>
    </DashboardProvider>
  );
}
